import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { APIService } from "../services/api.service";

@Injectable({providedIn:'root'})
export class LocalizationLoader {
    constructor(private _apiService: APIService) {
    }
    public getLocalization(language: string): Observable<any> {
        return this._apiService.fetch(`assets/locale/${language}.json`);
    }
    // public getLocalizations(language: string[]): Observable<any> {
    //     return this._apiService.fetch(`assets/locale/${language}.json`);
    // }
}
